import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Images } from '@constants/images';
import {AbstractClass} from "@classes/abstract.class";

@Component({
  standalone: false,
  selector: 'app-field-form-latlong',
  templateUrl: './special-latlong.component.html',
  styleUrls: ['./special-latlong.component.scss']
})
export class SpecialLatlongComponent implements OnInit {
  public images = Images;
  @Input() public myClass: AbstractClass | null = null;
  @Input() public name: string = '';
  @Output() setAction = new EventEmitter();
  public display: any;
  public positionReady = false;
  @Input() public centerLatLng: google.maps.LatLngLiteral = {
    lat: 0,
    lng: 0
  };
  public markerOptions: google.maps.MarkerOptions = {
    draggable: false
  };
  public zoom = 18;

  constructor() {
  }

  ngOnInit(): void {
    this.loadPosition();
  }

  public loadPosition = () => {
    if (this.myClass?.model[this.myClass?.idName] !== 0) {
      this.centerLatLng.lat = this.myClass?.model['latitude'];
      this.centerLatLng.lng = this.myClass?.model['longitude'];
      this.positionReady = true;
    } else {
      if (this.centerLatLng.lat === 0) {
        this.getPosition().then(
          pos => {
            this.centerLatLng.lat = pos.lat;
            this.centerLatLng.lng = pos.lng;
            this.positionReady = true;
          }).catch(
          err => {
            console.log(err);
            this.centerLatLng.lat = 8.985242406501088;
            this.centerLatLng.lng = -79.51922616578142;
            this.positionReady = true;
          }
        );
      } else {
        this.positionReady = true;
      }
    }
  }

  moveMap(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) {
      this.centerLatLng = (event.latLng.toJSON());
      this.setAction.emit(event.latLng.toJSON());
    }
  }
  move(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) this.display = event.latLng.toJSON();
  }

  getPosition(): Promise<any>
  {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resp => {
          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
          },
          err => {
          reject(err);
          });
    });

  }
}
